import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'au-no-auth-layout',
    templateUrl: './no-auth-layout.component.html',
    styleUrls: ['./no-auth-layout.component.scss'],
    imports: [RouterOutlet]
})
export class NoAuthLayoutComponent {}
